<standardized-side-panel *ngIf="options$ | async as options"
    [page]="'object'"
    [objectType]="objectType"
    [toggleTab]="options.standardizedSidePanel.tabToToggle"
    class="workspace-right-panel"
>
</standardized-side-panel>
